import React from "react";
import { Box, FormControlLabel, Grid } from "@mui/material";
import { FormikProps, getIn } from "formik";
import { CardPromptType, RangeType } from "../../../store/cardPrompt/types";
import TextInput from "../../../common/formElements/TextInput";
import CustomizedCheckbox from "../../../common/formElements/Checkbox";

interface BinRangeProps {
  binRange: RangeType;
  namespace: string;
  formikProps: FormikProps<CardPromptType>;
}

interface AccountCheckBoxProps {
  namespace: string;
  account: string;
  formikProps: FormikProps<CardPromptType>;
}

const AccountCheckBox = ({
  namespace,
  account,
  formikProps,
}: AccountCheckBoxProps) => {
  const selectedAccounts = getIn(formikProps.values, namespace + ".Account");
  const index = selectedAccounts ? selectedAccounts.indexOf(account) : -1;
  return (
    <FormControlLabel
      control={
        <CustomizedCheckbox
          checked={index > -1}
          onChange={() => {
            const newSelectedAccounts = [...selectedAccounts];
            if (index > -1) {
              newSelectedAccounts.splice(index, 1);
            } else {
              newSelectedAccounts.push(account);
            }
            formikProps.setFieldValue(
              namespace + ".Account",
              newSelectedAccounts
            );
          }}
        />
      }
      label={account}
    />
  );
};

const BinRange = ({ namespace, formikProps }: BinRangeProps) => {
  const possibleAccounts = ["Cheque", "Savings", "Credit", "Default"];
  return (
    <Grid
      container
      spacing={2}
      style={{
        width: "100%",
        background: "#fafafa",
        border: "1px solid #efefef",
        borderRadius: "5px",
        marginBottom: 5,
        padding: "10px",
      }}
    >
      <Grid item xs={12}>
        <Box display="flex" alignItems="center">
          <Box mr={2}>Accounts</Box>
          {possibleAccounts.map((account) => (
            <AccountCheckBox
              key={account}
              namespace={namespace}
              account={account}
              formikProps={formikProps}
            />
          ))}
        </Box>
      </Grid>

      <Grid item xs={12} md={4}>
        <TextInput fieldname={`${namespace}.From`} label="From" />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextInput fieldname={`${namespace}.To`} label="To" />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextInput fieldname={`${namespace}.Length`} label="Length" />
      </Grid>
    </Grid>
  );
};

export default BinRange;
